/** Which cave a session position means, per mode (docs/spec/02 §9, 03 §4). */

import type { Session } from '../../game/session';
import { currentPlayer } from '../../game/session';
import type { CaveTurn } from '../../game/turns';
import { dailyTurn, demoTurn, expeditionTurn, setTurn } from '../../game/turns';
import type { PlayRequest } from '../../ui/scene';

export type { CaveTurn } from '../../game/turns';
export { startPosition } from '../../game/turns';

export function caveForTurn(request: PlayRequest, session: Session): CaveTurn {
  const p = currentPlayer(session);
  switch (request.mode) {
    case 'classic':
    case 'deep':
      return setTurn(request.mode, p);
    case 'expedition':
      return expeditionTurn(request.seed, p);
    case 'daily':
      return dailyTurn(request.year, request.month, request.day);
    case 'practice':
      return { def: request.def, level: request.level, label: `${request.def.id}/${request.level}`, set: null };
    case 'demo':
      return demoTurn();
  }
}
